// Unica fuente de verdad de las metricas de la seccion Analisis.
// Las cards superiores y las tablas ("Composicion de las ventas" y
// "Ventas en cuotas") deben consumir este calculo, nunca uno propio.

export const numeroSeguro = (valor) => {
  const numero = Number(valor);
  return Number.isFinite(numero) ? numero : 0;
};

export const porcentaje = (valor, total) => {
  const totalSeguro = numeroSeguro(total);
  if (!totalSeguro) {
    return 0;
  }
  return Math.round((numeroSeguro(valor) / totalSeguro) * 100);
};

// Agrupa los montos por cantidad de cuotas. Mantiene siempre visibles los
// tramos fijos y suma dinamicamente cualquier otra cantidad que llegue.
const agruparCuotas = (cuotas) => {
  const cuotasFijas = [1, 3, 6, 9, 12];
  const montosPorCuota = new Map(cuotasFijas.map((cuota) => [cuota, 0]));

  (cuotas || []).forEach((cuota) => {
    const cuotaOriginal = Number(cuota.cuota);
    const cuotaNormalizada = cuotaOriginal === 13 ? 3 : cuotaOriginal;

    if (!Number.isFinite(cuotaNormalizada) || cuotaNormalizada <= 0) {
      return;
    }

    montosPorCuota.set(
      cuotaNormalizada,
      numeroSeguro(montosPorCuota.get(cuotaNormalizada)) +
        numeroSeguro(cuota.totalBruto)
    );
  });

  return [...montosPorCuota.entries()]
    .sort((a, b) => a[0] - b[0])
    .map(([label, monto]) => ({ label, monto }));
};

export const calcularMetricasAnalisis = (datosBack = {}) => {
  const { debitoFacturacion, totalOperaciones, cuotas } = datosBack;

  const cuotasAgrupadas = agruparCuotas(cuotas);

  // 1 Pago: cuota === 1. Cuotas: cuota > 1 (cualquier cantidad futura entra
  // aca automaticamente).
  const unPago = cuotasAgrupadas
    .filter((grupo) => grupo.label === 1)
    .reduce((acc, grupo) => acc + grupo.monto, 0);
  const enCuotas = cuotasAgrupadas
    .filter((grupo) => grupo.label > 1)
    .reduce((acc, grupo) => acc + grupo.monto, 0);

  const debito = numeroSeguro(debitoFacturacion);
  const credito = unPago + enCuotas;
  const total = debito + credito;

  return {
    cuotasAgrupadas,
    // Total de la tabla "Ventas en cuotas" === Credito.
    totalCuotas: credito,
    unPago,
    enCuotas,
    debito,
    credito,
    total,
    cantidadOperaciones: numeroSeguro(totalOperaciones),
  };
};

export default calcularMetricasAnalisis;
